import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import RenderClientesStatus from './components/RenderClientesStatus';

class ClientesList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: [],
    };
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  get columns() {
    return [
      {
        key: 'nombre_comercial',
        title: 'Empresa',
        dataIndex: 'nombre_comercial',
      },
      {
        key: 'rfc',
        title: 'RFC',
        dataIndex: 'rfc',
      },
      {
        key: 'email',
        title: 'Email',
        dataIndex: 'email',
      },
      {
        key: 'hits',
        title: 'Hits',
        dataIndex: 'hits',
        align: 'right',
      },
      {
        key: 'hits_balance',
        title: 'Balance',
        dataIndex: 'hits_balance',
      },
      {
        key: 'created_at',
        title: 'Registro',
        dataIndex: 'created_at',
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        className: 'text-center',
        render: (item) => <RenderClientesStatus item={item} />,
      },
    ];
  }

  paginate(meta) {
    const { filters = {} } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selected: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { data, busy } = this.props.list;
    const { onRowClick, selectedRowKeys } = this.props;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          ...this.getRowSelectionConfig(),
        }}
        onRowClick={onRowClick}
        onRow={(item) => {
          return {
            className: item.highlight ? 'row-highlighted' : '',
          };
        }}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.admin.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.clientes.list };
};

export default connect(useStore, mapState, mapActions)(ClientesList);
